import React from 'react';
import api from './api';
import './Doctors.css';
import PatientSequences from './PatientSequences';
import Recomms from './Recomms';

import AuthContext from '../context/AuthProvider';

class PatientDailyActivity extends React.Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);

    this.state = {
      patients: [],
      selectedPatient: null,
      isEditMode: false,
      isModalOpen: false,
      modalData: null,
      hasModalChanged: false,
      activeTab: 0,
    };
  }

  componentDidMount() {
    const patientData = this.props.patientData;
    if (patientData) {
      console.log('Selected Patient ==== ', patientData);
      this.setState({ selectedPatient: patientData });
    }
  }

  getPatients() {
    const auth = this.context.auth;

    api
      .get(`${process.env.REACT_APP_URL}/patients/therapist/${auth.username}`)
      .then((response) => {
        this.setState({ patients: response.data });
      })
      .catch((error) => {
        console.error('Error fetching patients', error);
      });
  }

  handleEditPatient(id) {
    const patient = this.state.patients.find((p) => p._id === id);
    this.setState({
      selectedPatient: patient,
      isModalOpen: true,
      isEditMode: true,
    });
  }

  handlePatientDetails(patient) {
    this.setState({
      selectedPatient: patient,
      isEditMode: true,
      isModalOpen: true,
      hasModalChanged: true,
      modalData: patient,
    });
  }

  handleClose = () => {
    this.setState({
      isModalOpen: false,
      selectedPatient: null,
      isEditMode: false,
      hasModalChanged: false,
      modalData: null,
    });
    this.getPatients();
  };

  setActiveTab = (index) => {
    this.setState({ activeTab: index });
  };

  renderTabButton(label, index) {
    const isActive = this.state.activeTab === index;
    return (
      <button
        key={index}
        className={`tab-button ${isActive ? 'active' : ''}`}
        onClick={() => this.setActiveTab(index)}
      >
        {label}
      </button>
    );
  }

  renderTabContent() {
    const { selectedPatient, activeTab } = this.state;

    if (!selectedPatient) return null;

    switch (activeTab) {
      case 0:
        return (
          <div>
             <PatientSequences patientCard={selectedPatient.patientCard}  activeTab={3} />
          </div>
        );
      case 1:
        return (
          <div>
            <Recomms patientCard={selectedPatient.patientCard} /> 
            
          </div>
        );
      default:
        return null;
    }
  }

  render() {
    const { selectedPatient } = this.state;

    return (
      <div className="patient-main">
        <div className="form-sections">
          <div className="form-header">
            <h4>Today's Sequences</h4>
            <form>
              <div className="ele">
                <label>
                  Health-Card Id: {selectedPatient?.patientCard}
                </label>
                <label>
                  Name: {selectedPatient?.name} / {selectedPatient?.number}
                </label>
              </div>
              <div className="ele">
                <label>Age: {selectedPatient?.age}</label>
              </div>
            </form>

            <div className="tab-header">
              {this.renderTabButton('Sequences', 0)}
              {this.renderTabButton('Recommendations', 1)}
            </div>

            <div className="tab-content">
              {this.renderTabContent()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PatientDailyActivity;
